export function isValid(v) {
    const test = v != null && v != "" && v != {} && (typeof v != 'undefined')
    return test;
}